<template>
  <div
    class="col-start-1 col-span-12 row-start-1 row-span-6 z-0">
    <Map ref="MapMain" :poi="true" />
    <Info />
    <Sidebar>
      <SideDetailKapal />
    </Sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Map from './Map.vue'
import Info from './Info.vue'
import Sidebar from './Sidebar'
import SideDetailKapal from './SideDetailKapal.vue'

export default {
  name: 'Main',
  computed: {
    ...mapGetters(['kapal'])
  },
  components: {
    Map,
    Info,
    Sidebar,
    SideDetailKapal
  },
  methods: {
    ...mapActions([
      'toShowSidebar',
      'toHideSidebar'
    ])
  },
  watch: {
    kapal() {
      if (this.kapal.transmitter) {
        this.toShowSidebar()
      } else {
        this.toHideSidebar()
      }
    }
  },
  mounted: async function () {
    await this.$refs.MapMain.init()
  }
}
</script>
